<div class="flex flex-col gap-6">
    <vw-header-back-btn (back)="onCloseLocationForm()"></vw-header-back-btn>

    <h2 class="text-[#062825] text-2xl font-semibold">{{ location?.name ||
        ('profile.addresses.edit-address.create-location.title' | translate) }}</h2>

    <!-- Encart explicatif : zone (espace) vs planche -->
    <div class="flex gap-2 rounded-2xl bg-[#DAF2E0] p-3 text-[13px] leading-snug text-[#185545]">
        <span>📍</span>
        <p>{{ 'profile.addresses.edit-address.edit-locations.intro' | translate }}</p>
    </div>

    <!-- Nom (obligatoire) -->
    <div class="flex flex-col gap-2">
        <label class="text-xs font-normal text-[#9BA6A1] flex">{{
            'profile.addresses.edit-address.edit-locations.name.label' | translate }} *</label>
        <vw-text-input [(value)]="name" (valueChange)="onNameChange($event)"></vw-text-input>
        @if (submitAttempted && !isNameValid) {
            <p class="text-xs text-red-500">{{ 'profile.addresses.edit-address.edit-locations.name.error' | translate }}</p>
        } @else {
            <p class="text-xs text-[#9BA6A1]">{{ 'profile.addresses.edit-address.edit-locations.name.placeholder' | translate }}</p>
        }
    </div>

    <!-- Type de zone : cartes illustrées (sans « Bac potager ») -->
    <div class="flex flex-col gap-2">
        <label class="text-xs font-normal text-[#9BA6A1] flex">{{
            'profile.addresses.edit-address.edit-locations.type.label' | translate }}</label>
        <vw-choice-selector [options]="typeOptions" [(value)]="selectedType" variant="cards" [columns]="3"></vw-choice-selector>
    </div>

    <!-- Ensoleillement : pills -->
    <div class="flex flex-col gap-2">
        <label class="text-xs font-normal text-[#9BA6A1] flex">{{
            'profile.addresses.edit-address.edit-locations.sunshine.label' | translate }}</label>
        <vw-choice-selector [options]="sunshineOptions" [(value)]="selectedSunshine" variant="chips"></vw-choice-selector>
        <p class="text-xs text-[#9BA6A1]">{{ 'profile.addresses.edit-address.edit-locations.sunshine.help' | translate }}</p>
    </div>

    <!-- Dimensions (optionnel) → surface dérivée + futures suggestions de planches -->
    <div class="flex flex-col gap-2.5">
        <div class="flex items-center justify-between">
            <label class="text-xs font-normal text-[#9BA6A1] flex">{{
                'profile.addresses.edit-address.edit-locations.dimensions.label' | translate }}</label>
            <span class="rounded-full bg-gray-100 px-2 py-0.5 text-[11px] font-medium text-[#9BA6A1]">{{
                'profile.addresses.edit-address.edit-locations.dimensions.optional' | translate }}</span>
        </div>
        <div class="flex items-end gap-3">
            <label class="flex-1">
                <span class="mb-1 block text-[11px] text-[#9BA6A1]">{{
                    'profile.addresses.edit-address.edit-locations.dimensions.width' | translate }}</span>
                <div class="relative">
                    <input type="number" inputmode="decimal" min="0.1" step="0.1" [(ngModel)]="width"
                        class="h-11 w-full rounded-xl border border-[#DFE2E1] px-3 pr-7 text-base text-[#3C4340] outline-none focus:border-[#317756]" />
                    <span class="absolute right-3 top-1/2 -translate-y-1/2 text-sm text-[#9BA6A1]">m</span>
                </div>
            </label>
            <span class="pb-3 text-lg text-[#C4CAC7]">×</span>
            <label class="flex-1">
                <span class="mb-1 block text-[11px] text-[#9BA6A1]">{{
                    'profile.addresses.edit-address.edit-locations.dimensions.length' | translate }}</span>
                <div class="relative">
                    <input type="number" inputmode="decimal" min="0.1" step="0.1" [(ngModel)]="length"
                        class="h-11 w-full rounded-xl border border-[#DFE2E1] px-3 pr-7 text-base text-[#3C4340] outline-none focus:border-[#317756]" />
                    <span class="absolute right-3 top-1/2 -translate-y-1/2 text-sm text-[#9BA6A1]">m</span>
                </div>
            </label>
            @if (derivedSurface) {
                <div class="pb-1 text-right shrink-0">
                    <span class="mb-1 block text-[11px] text-[#9BA6A1]">{{
                        'profile.addresses.edit-address.edit-locations.dimensions.surface' | translate }}</span>
                    <span class="inline-block rounded-lg bg-[#DAF2E0] px-2.5 py-2 text-sm font-semibold text-[#185545]">≈ {{ derivedSurface }} m²</span>
                </div>
            }
        </div>
        <p class="text-xs text-[#9BA6A1]">{{ 'profile.addresses.edit-address.edit-locations.dimensions.help' | translate }}</p>
    </div>

    <vw-button class="mx-auto" (click)="onSubmitLocationForm()"
        label="{{ 'profile.addresses.edit-address.button' | translate }}" [iconPosition]="'left'"
        [color]="'bg-primary hover:bg-black'" [loading]="isSubmittingLocation" [disabled]="!isNameValid"
        [iconTemplate]="iconTemplate" [textColor]="'text-white hover:text-white'" customClass="text-center mx-auto">
        <ng-template #iconTemplate>
            <vw-check-icon></vw-check-icon>
        </ng-template>
    </vw-button>
</div>
